import { GzLoaderWebComponent } from './component/GzLoaderWebComponent';
import { WEB_COMPONENT_GZ_LOADER } from '../../webcomponents.constants';

export { GzLoaderWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_LOADER, GzLoaderWebComponent);

/**
 * Examples:
 * Basic single row single column loader (rows = 1, columns = 1); this will be as wide as its parent.
 * <gz-loader></gz-loader>
 *
 * Loader with 6 rows => <gz-loader rows="6"></gz-loader>
 *
 * Single row loader with 5 columns => <gz-loader columns="5"></gz-loader>
 *
 * Loader with 12 rows and 8 columns => <gz-loader rows="12" columns="8"></gz-loader>
 *
 * Loader with 8 columns and 12 rows split by horizontal divider =>
 * <gz-loader rows="12" splitRowsByLine columns="8"></gz-loader>
 *
 * Loader with 12 rows and 8 columns split by a vertical divider =>
 * <gz-loader rows="12" columns="8" splitColumnsByLine></gz-loader>
 *
 * Loaders with custom width for the last column in the row, as seen in the Threats log:
 * https://xd.adobe.com/view/1cf9dbcb-606d-4d1d-724e-44349df67d6b-6ac8/screen/f2692fa7-d232-4222-8c81-51345d32770e/
 *
 * Grid columns loader: <gz-loader columns="7" lastColumnPixelWidth="184"></gz-loader>
 *
 * Grid rows loader: <gz-loader columns="5" rows="9" lastColumnPixelWidth="72"></gz-loader>
 *
 */
